// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App"; // Main App component
import reportWebVitals from "./reportWebVitals";
// Removed AuthProvider from here, it's inside App now
import { BrowserRouter as Router } from "react-router-dom"; // Keep Router here

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Single Top-Level Router */}
    <Router>
      {/* App component contains Providers and Routes */}
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
